import { render } from "./About.vue?vue&type=template&id=0ea6a7af"
const script = {}

import "./About.vue?vue&type=style&index=0&id=0ea6a7af&lang=scss"
script.render = render

export default script